export const DASHBOARD_REQUEST = 'DASHBOARD_REQUEST';
export const DASHBOARD_REQUEST_SUCCESS = 'DASHBOARD_REQUEST_SUCCESS';
export const DASHBOARD_REQUEST_ERROR = 'DASHBOARD_REQUEST_ERROR';
